import api from './client'; // Import the same shared client
const getAdminPassword = () => sessionStorage.getItem('adminPass') || '';

// Now your existing export will work on iPad!
export const getCurrentUser = () => 
    api.get('/users/me').then(res => res.data);

export const completeProfile = async (userId, formData) => {
  const token = localStorage.getItem('X-Auth-Token');
  const response = await api.post(
    `/users/complete-profile/${userId}`,
    formData,
    { headers: { 'X-Auth-Token': token } }
  );
  return response.data;
};

export const updateProfile = async (profileData) => {
  const response = await api.put(`/users/profile/update`, profileData);
  return response.data;
};

// userApi.js
export const logout = () => api.post('/logout');

// Inside userApi.js

// Add this alongside your other exports
export const searchUsers = (query) => 
    api.get('/users/search', { params: { query } }).then(res => res.data);

// --- Profile & User Data ---
/**
 * Fetches a public profile with timezone-aware calendar data
 */
export const getPublicProfile = (userId, tz) => 
    api.get(`/users/profile/${userId}`, { params: { timeZone: tz } }).then(res => res.data);


export const getPublicGoals = async (userId, timeZone) => {
  const response = await api.get(`/users/${userId}/goals/public`, {
    params: { timeZone },
  });
  return response.data;
};

export const getPublicCalendarContributions = async (userId, from, to, timeZone) => {
  const response = await api.get(`/users/${userId}/calendar/contributions/public`, {
    params: {
      from,
      to,
      timeZone,
    },
  });

  return response.data;
};

export const getPublicGoalDetail = async (targetId, goalId, timeZone) => {
  const response = await api.get(`/users/${targetId}/goals/${goalId}/public`, {
    params: { timeZone },
  });

  return response.data;
};

export const getPublicGoalChecks = async (targetId, goalId, from, to) => {
  const response = await api.get(`/users/${targetId}/goals/${goalId}/checks/public`, {
    params: {
      from,
      to,
    },
  });

  return response.data;
};
// --- Social Actions ---

export const getSocialList = (userId, type) => 
    api.get(`/api/social/${userId}/${type}`).then(res => res.data);

export const getLeaderboardData = (type, currentUserId, tz) => {
  // 1. Ensure these paths match your Backend @RequestMapping
  const endpoint = type === 'global' 
    ? `/api/social/global-leaderboard` 
    : `/api/social/${currentUserId}/following-detailed`; // Verify if '/api' is needed

  return api.get(endpoint, { 
    params: { 
      timeZone: tz,
      // If your backend isn't using the URL ID, it might expect it as a param:
      userId: currentUserId 
    } 
  }).then(res => res.data);
};

export const getHighlyActivePlayers = (viewType, currentUserId, tz) => {
  return api.get('/users/all', { 
    params: { 
      view: viewType,      // 'global' or 'following'
      userId: currentUserId,
      timeZone: tz 
    } 
  }).then(res => res.data);
};

// Add this to your API file
export const testSession = () => 
    api.get('/api/test/session').then(res => res.data);


// Change this:
export const deleteUserAccount = async () => {
    // Just use 'api' (it already has the token interceptor!)
    const response = await api.delete('/users/me'); 
    return response.data;
};

export const updateBio = async (userId, newBio) => {
  const response = await api.patch(`/users/me/bio`, { bio: newBio });
  return response.data;
};

export const toggleReaction = (targetUserId, reactionType, timeZone) =>
  api.post(`/api/reactions/${targetUserId}/${reactionType}`, null, {
    params: { timeZone },
  });

export const getReactions = (targetUserId, timeZone) =>
  api.get(`/api/reactions/${targetUserId}`, {
    params: { timeZone },
  });

  export const getLifetimeReactions = (targetUserId, timeZone) =>
  api.get(`/api/reactions/${targetUserId}`, {
    params: { timeZone },
  });

  export const uploadProfilePic = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post('/users/me/profile-pic', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

  //Service Request Api

  // Stripe
export const createPaymentIntent = (amount) =>
  api.post('/api/stripe/create-payment-intent', { amount }).then(res => res.data);

export const verifyPayment = (paymentIntentId) =>
  api.get(`/api/stripe/verify/${paymentIntentId}`).then(res => res.data);

// Service Requests
export const submitServiceRequest = (dto) =>
  api.post('/api/service-requests', dto).then(res => res.data);

export const getMyServiceHistory = () =>
  api.get('/api/service-requests/my-history').then(res => res.data);

// Admin
export const getAdminPendingRequests = () =>
  api.get('/api/admin/requests/pending', {
    headers: { 'X-Admin-Password': getAdminPassword() }
  }).then(res => res.data);

export const getAdminAllRequests = () =>
  api.get('/api/admin/requests/all', {
    headers: { 'X-Admin-Password': getAdminPassword() }
  }).then(res => res.data);

  export const approveServiceRequest = (requestId, adminNote = null) =>
  api.post(`/api/admin/requests/${requestId}/approve`, { adminNote }, {
    headers: { 'X-Admin-Password': getAdminPassword() }
  }).then(res => res.data);

export const rejectServiceRequest = (requestId, adminNote) =>
  api.post(`/api/admin/requests/${requestId}/reject`, { adminNote }, {
    headers: { 'X-Admin-Password': getAdminPassword() }
  }).then(res => res.data);

  export const submitRequestReply = (requestId, reply) =>
  api.post(`/api/service-requests/${requestId}/reply`, { reply }).then(res => res.data);

export const submitAdminFollowUp = (requestId, followUp, reApprove) =>
  api.post(`/api/admin/requests/${requestId}/follow-up`, { followUp, reApprove }, {
    headers: { 'X-Admin-Password': getAdminPassword() }
  }).then(res => res.data);

export const getAdminPendingReplies = () =>
  api.get('/api/admin/requests/pending-replies', {
    headers: { 'X-Admin-Password': getAdminPassword() }
  }).then(res => res.data);

export const removeProfilePic = async () => {
  const response = await api.delete('/users/me/profile-pic');
  return response.data;
};

export const getTodayReactionUsers = (targetUserId, timeZone) =>
  api.get(`/api/reactions/${targetUserId}/today/users`, {
    params: { timeZone },
  }).then((res) => res.data);

export default api;
